import Helper from '@ember/component/helper';
import { inject as service } from '@ember/service';
import AppSettings from 'volta/services/app-settings';

export default class GetFeatureHelper extends Helper {
  @service appSettings!: AppSettings;

  compute([feature]: [string]) {
    return this.appSettings.getFeature(feature);
  }
}
